import React, { useEffect, useState } from 'react';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import { Bar } from 'react-chartjs-2';
import CitySocChart from './CitySocChart';
import './RangeAnalysis.css';
import moment from 'moment';

export default function RangeSocAnalysis1(props) {

    const { isLoading, error, sendReq: fetchData } = useHttp();
    let { title, template_id, show, soarting, gloablfilter } = props;
    let temp = [];

    const [monthLabel, setMonthLabel] = useState([]);
    const [monthData, setMonthData] = useState([]);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [duration, setDuration] = useState("6M");
    const [sDate, setSDate] = useState();
    const [eDate, setEDate] = useState();

    let apiprops = {};
    apiprops.startDate =  gloablfilter.startDate
    apiprops.endDate =  gloablfilter.endDate
    apiprops.city = gloablfilter.CITY
    apiprops.depo = gloablfilter.DEPO

    const enddate = moment().utc().format('YYYY-MM-DD[T]00:00:00.000[Z]')
    const startdate = moment().utc().subtract(180, 'days').startOf('day').format('YYYY-MM-DD[T]00:00:00.000[Z]');

    const handleDurationSelection = async (durationValue) => {
      await updateDates(durationValue);
    }
    
    const updateDates = async (durationValue) => {
      setDuration(durationValue);
      if (durationValue === "7D") {
        setEDate(moment().format('YYYY-MM-DD'));
        setSDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
      } else if (durationValue === '1M') {
        setEDate(moment().format('YYYY-MM-DD'));
        setSDate(moment().subtract(30, 'days').format('YYYY-MM-DD'));
      } else if (durationValue === '3M') {
        setEDate(moment().format(('YYYY-MM-DD')));
        setSDate(moment().subtract(90, 'days').format('YYYY-MM-DD'));
      } else if (durationValue === '6M') {
        setEDate(moment().format('YYYY-MM-DD'));
        setSDate(moment().subtract(182, 'days').format('YYYY-MM-DD'));
      } else if (durationValue === '1Y') {
        setEDate(moment().format('YYYY-MM-DD'));
        setSDate(moment().subtract(365, 'days').format('YYYY-MM-DD'));
      }
    }

    useEffect(() => {
        fetchData(
          {
            url: API_URL_MAIN + "trend_analysis_drive_bus/monthWiseSocTrend",
            body: { filterdata: {
              "CITY" : apiprops.city,
              "DEPO": apiprops.depo,
              "LOB": [],
              "PL": [],
              "PPL": [],
              "SOC": 0,
              "VIN_NUM": [],
              "endDate": eDate ? eDate : enddate,
              // "endDate": eDate ? eDate : apiprops.endDate,
              "pageSelected": 1,
              "startDate": sDate ? sDate : startdate,
              // "startDate": sDate ? sDate : apiprops.startDate,
              "AIR_VENTILATION": "",
          }},
          },
          responceDataDate
        );
    }, [gloablfilter,sDate, eDate,duration]);

    const responceDataDate = (data) =>{
      setMonthLabel(data.monthname)
      setMonthData(data.monthrange)
    }
    
    const colorPalette = [
      '#02559b',
      '#83a3ce',
      '#ced9e9',
      '#6081AA',
      '#3D6087',
      '#D4DFEB',
      '#184165',
      '#002446',
      '#D9F9FF',
      '#53749D',
      '#AFCFFC',
      '#949BE6',
    ];

    const datasets = [{
        label: '',
        data: monthData,
        backgroundColor: colorPalette.slice(0, monthData.length),
        borderColor: colorPalette.slice(0, monthData.length).map(color => color.replace('0.5', '1')), // Use a darker shade for borderColor
        borderWidth: 1,
        barThickness: 40,
    }];

    const data = {
      labels: monthLabel,
      datasets,
    };

    const options = {
      scales: {
        x: {
            barPercentage: 0.2, // Adjust the value to decrease or increase the gap between bars
            categoryPercentage: 0.2,// Adjust the value to decrease or increase the gap between bars
          },
        y: {
          beginAtZero: true
        }
      },
      plugins: {
        legend: {
          display: false,
        },
      },
      elements: {
        line: {
          tension: 0,
        },
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
          top: 0,
          bottom: 0,
        },
      },
      maintainAspectRatio: false, 
      responsive: true,
      scales: {
        x: {
          grid: {
            display: false, 
          },
        },
        y: {
          grid: {
            display: false,
          },
        },
      },
        onClick: (event, elements) => {
            if (elements.length > 0) {
                const clickedElementIndex = elements[0].index;
                const clickedDataValue = data.datasets[0].data[clickedElementIndex];
                const clickedLabel = data.labels[clickedElementIndex];
                setClickedIndex(clickedElementIndex); 
            }
        },
    };


  return (
    <>
      <div className='container-fluid mt-3'>
        {/* <div className='row' style={{textAlign:"left", color:"blue", fontSize:"30px"}}><b>Trend Analysis</b></div> */}
      
      <div className='row' style={{backgroundColor:"#fff", boxShadow:"0px 3px 6px #00000027"}}>
            {/* <div className='col-md-12'>
              <div className='row second mt-0'>
                <div className='col-md-12' style={{border:"", backgroundColor:"#fff"}}> */}
          {/* <div className="row mb-3 discharge_titlebg_bus_trend"> */}
          <div className={clickedIndex === null ? 'row mt-1 mb-2 discharge_titlebg_bus_trend' : 'row d-none mt-1 mb-2 discharge_titlebg_bus_trend'}>
            <div className="col-md-7 ">
              <div className="text-fit">Discharge Soc(%) Analysis</div>
            </div>
            <div className="col-md-5 py-1">
              <div className="mt-1" style={{border:"1px solid #b7c0ca", padding:"3px", borderRadius:"5px", float:"right"}}>
                <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px", border:"0px" }}>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a 
                      style={{
                        justifyContent: "center",
                        backgroundColor: duration === "7D" ? "#f2f2f2" : "transparent",
                        color: duration === "7D" ? "#fff" : "#000" // Text color for better visibility
                      }}
                      className={
                        (duration === "7D") ? "nav-link active py-0" : "nav-link py-0"
                      }
                      data-bs-toggle="tab"
                      href="#day"
                      id="7D"
                      // onClick={(e) => setDuration(e, "7D")}
                      onClick={() => handleDurationSelection("7D")}
                    >
                      7D
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a
                      style={{
                        justifyContent: "center",
                        backgroundColor: duration === "1M" ? "#f2f2f2" : "transparent",
                        color: duration === "1M" ? "#fff" : "#000" // Text color for better visibility
                      }}
                      className={
                        (duration === "1M") ? "nav-link active py-0" : "nav-link py-0"
                      }
                      data-bs-toggle="tab"
                      href="#mon"
                      onClick={() => handleDurationSelection("1M")}
                    >
                      1M
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a
                      style={{
                        justifyContent: "center",
                        backgroundColor: duration === "3M" ? "#f2f2f2" : "transparent",
                        color: duration === "3M" ? "#fff" : "#000" // Text color for better visibility
                      }}
                      className={
                        (duration === "3M") ? "nav-link active py-0" : "nav-link py-0"
                      }
                      data-bs-toggle="tab"
                      href="#mon"
                      onClick={() => handleDurationSelection("3M")}
                    >
                      3M
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a
                      style={{
                        justifyContent: "center",
                        backgroundColor: duration === "6M" ? "#f2f2f2" : "transparent",
                        color: duration === "6M" ? "#fff" : "#000" // Text color for better visibility
                      }}
                      className={
                        (duration === "6M") ? "nav-link active py-0" : "nav-link py-0"
                      }
                      data-bs-toggle="tab"
                      href="#mon"
                      onClick={() => handleDurationSelection("6M")}
                    >
                      6M
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a
                      style={{
                        justifyContent: "center",
                        backgroundColor: duration === "1Y" ? "#f2f2f2" : "transparent",
                        color: duration === "1Y" ? "#fff" : "#000" // Text color for better visibility
                      }}
                      className={
                        (duration === "1Y") ? "nav-link active py-0" : "nav-link py-0"
                      }
                      data-bs-toggle="tab"
                      href="#year"
                      onClick={() => handleDurationSelection("1Y")}
                    >
                      1Y
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* </div> */}
          <div>
          {(clickedIndex !== null) ? <CitySocChart index={clickedIndex} apiprops={apiprops} monthLabel={monthLabel} duration={duration}/>
            :(<Bar data={data} options={options} type={'bar'} style={{height:"230px"}}/>)
          }
          </div>
                {/* </div>
              </div>
            </div> */}
        </div> 
      </div> 
    </>
  )
}

